<template>
  <div class="list-card" @click="goDetail()">
    <div class="card-header">
      <div class="header-content">
        <label>直播时间</label>
        <span>{{ cardData.live_time }}</span>
      </div>
      <div class="live-status">
        <el-image class="status-icon" :src="statusIcon" fit="contain" />
        <span class="status-text" :class="statusColor">{{ statusText }}</span>
      </div>
    </div>
    <div class="card-body">
      <el-image class="live-cover" :src="cardData.live_cover || DefaultCover" fit="cover" />
      <div class="live-info">
        <h3>{{ cardData.title }}</h3>
        <span>{{ cardData.type }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import DefaultCover from '@/assets/images/default_cover.png';
import StatusReady from "@/assets/images/icons/broadcast/status-ready.svg";
import StatusLiving from "@/assets/images/icons/broadcast/status-living.svg";
import StatusEnd from "@/assets/images/icons/broadcast/status-end.svg";
import StatusReplay from "@/assets/images/icons/broadcast/status-replay.svg";
export default {
  props: {
    cardData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      DefaultCover,
      StatusReady,
      StatusLiving,
      StatusEnd,
      StatusReplay,
    }
  },
  computed: {
    statusIcon() {
      switch (this.cardData.status) {
        case 1:
          if (this.cardData.review_url) {
            return this.StatusReplay;
          }
          return this.StatusEnd;
        case 2:
          return this.StatusReady;
        case 3:
          return this.StatusLiving;
        default:
          return this.StatusEnd;
      }
    },
    statusText() {
      switch (this.cardData.status) {
        case 1:
          if (this.cardData.review_url) {
            return '看回放';
          }
          return '已结束';
        case 2:
          return '待直播';
        case 3:
          return '直播中';
        default:
          return '已结束';
      }
    },
    statusColor() {
      switch (this.cardData.status) {
        case 1:
          return 'end-clor';
        case 2:
          return 'ready-clor';
        case 3:
          return 'living-clor';
        default:
          return 'end-clor';
      }
    }
  },
  methods: {
    goDetail() {
      if (this.cardData.status === 3 && this.cardData.live_url) {
        window.location.href = this.cardData.live_url
      } else {
        window.location.href = `/m/broadcast/detail/${this.cardData.id}`
      }
    },
  },
}
</script>

<style lang="less" scoped>
.list-card {
  margin-bottom: 0.75rem;
  width: 100%;

  .card-header {
    display: flex;
    align-items: flex-start;

    .header-content {
      flex: 1;
      height: 4rem;
      padding: 0.25rem 1rem 2.25rem;
      color: #FFFFFF;
      background-color: #2173EA;
      border-radius: 0.75rem;
      display: flex;
      align-items: center;
      gap: 0.625rem;

      &::after {
        content: '';
        position: absolute;
        width: 100%;
        height: 2rem;
        left: 0;
        bottom: 0;
        border-radius: 0.75rem;
        background-color: #66D5C8;
      }

      label {
        width: 6rem;
        font-size: 0.875rem;
        font-weight: bold;
      }
      span {
        font-size: 0.75rem;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }

    .live-status {
      margin-left: 0.5rem;
      width: 5rem;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 0.5rem;

      .status-icon {
        width: 1.5rem;
        height: 1.5rem;
      }
      .status-text {
        font-size: 0.875rem;
        font-weight: bold;

        &.end-clor {
          color: #A0A0A0;
        }
        &.ready-clor {
          color: #24B9A7;
        }
        &.living-clor {
          color: #FFA600;
        }
      }
    }
  }
  .card-body {
    margin-top: -1.625rem;
    padding: 0.75rem 0.5rem;
    width: 100%;
    display: flex;
    gap: 0.5rem;
    border: 1px solid #E4EFFF;
    background: linear-gradient(to bottom, #E4EFFF, #FFFFFF);
    border-radius: 0.75rem;

    .live-cover {
      width: 7.5rem;
      height: 5rem;
      border-radius: 0.75rem;
    }

    .live-info {
      flex: 1;

      h3 {
        height: 2.5rem;
        font-size: 0.875rem;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      span {
        margin-top: 0.625rem;
        width: fit-content;
        height: 1.5rem;
        padding: 0 0.75rem;
        font-size: 0.75rem;
        background-color: #E4EBFF;
        color: #3160F6;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0.325rem;
      }
    }
  }
}
</style>
